import { AutoMap } from "@automapper/classes";

export class DisponibiliteClient {

    @AutoMap()
    From!: Date;
    @AutoMap()
    To!: Date;

}
